import { animate, state, style, transition, trigger } from '@angular/animations';

export const FLIP_ANIMATION = trigger('rotateAnimation', [
  state('void', style({ transform: 'rotate(0deg)' })),
  state('rotate', style({ transform: 'rotate({{rotate}}deg)' })),
  transition('void => rotate', animate('500ms cubic-bezier(0,.74,0,1)'))
]);

// trigger('scaleInOut', [
//   state('scaleIn', style({ transform: 'scale(1)' })),
//   state('scaleOut', style({ transform: 'scale(0)' })),
//   transition('scaleIn => scaleOut', animate('1s ease-in')),
//   transition('scaleOut => scaleIn', animate('1s ease-out'))
// ]);
